import { TYPES } from '@Types';
import { inject, injectable } from 'inversify';
import { ApiClient } from '@Api';
import {
  RequestAction,
  RequestFailure,
  RequestSuccess,
} from '@Repository/RequestAction';
import { Locale } from '@Repository/locale';
import { UserBugReport } from '@Models';
import { UserBugReportMapper } from '@Mapper/user/user-bug-report.mapper';

@injectable()
export class UserBugReportRepository {
  @inject(TYPES.Locale) private _locale!: Locale;
  @inject(TYPES.Api.ApiClient) private _apiClient!: ApiClient;
  @inject(TYPES.Mapper.UserBugReportMapper)
  private _mapper!: UserBugReportMapper;

  public async create(item: UserBugReport): Promise<RequestAction> {
    try {
      const dto = this._mapper.mapDto(item);

      await this._apiClient.user.createUserBugReport({
        locale: this._locale.getlocale(),
        requestBody: dto,
      });
      return new RequestSuccess();
    } catch (error: any) {
      console.log('error', error);
      return new RequestFailure({ error: error });
    }
  }
}
